var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.3121 0.388672H7.7C3.104 0.388672 0.5 2.99267 0.5 7.58867V20.1887C0.5 24.7847 3.104 27.3887 7.7 27.3887H20.3121C24.908 27.3887 27.5 24.7847 27.5 20.1887V7.58867C27.5 2.99267 24.908 0.388672 20.3121 0.388672Z",
    fill: "#CE2600"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9561_82550)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.9729 10.8813V15.1646L19.8265 14.1799C19.2779 13.7087 18.3917 13.7087 17.8431 14.1799L14.9172 16.6908C14.3686 17.1621 13.4824 17.1621 12.9338 16.6908L12.6947 16.4939C12.1953 16.0578 11.4005 16.0156 10.8379 16.3954L7.37748 18.7164L7.30012 18.7727C7.03988 18.21 6.90625 17.5419 6.90625 16.7752V10.8813C6.90625 8.32116 8.43248 6.79492 10.9926 6.79492H16.8865C19.4467 6.79492 20.9729 8.32116 20.9729 10.8813Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8102 6.5043C20.37 6.15308 19.811 5.94531 19.2025 5.94531C18.5941 5.94531 18.0252 6.15802 17.58 6.51914C16.9814 6.98908 16.6055 7.72615 16.6055 8.54237C16.6055 9.02715 16.744 9.49215 16.9814 9.878C17.1645 10.1798 17.4019 10.4419 17.6839 10.6448C18.1093 10.9564 18.6336 11.1394 19.2025 11.1394C19.8604 11.1394 20.4541 10.897 20.9092 10.4914C21.112 10.3232 21.2851 10.1154 21.4236 9.878C21.6611 9.49215 21.7996 9.02715 21.7996 8.54237C21.7996 7.71626 21.4137 6.97919 20.8102 6.5043ZM19.2025 9.77906C19.2025 9.09641 18.6485 8.54237 17.9658 8.54237C18.6485 8.54237 19.2025 7.98833 19.2025 7.30568C19.2025 7.98833 19.7566 8.54237 20.4392 8.54237C19.7566 8.54237 19.2025 9.09641 19.2025 9.77906Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9735 15.1652V16.7759C20.9735 19.336 19.4473 20.8622 16.8872 20.8622H10.9933C9.19978 20.8622 7.90565 20.1097 7.30078 18.7733L7.37815 18.7171L10.8385 16.3961C11.4012 16.0163 12.196 16.0585 12.6953 16.4945L12.9344 16.6915C13.483 17.1627 14.3692 17.1627 14.9178 16.6915L17.8437 14.1806C18.3923 13.7093 19.2785 13.7093 19.8271 14.1806L20.9735 15.1652Z",
    fill: "#CE2600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9561_82550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.88,
    height: 16.88,
    fill: "white",
    transform: "translate(5.5 5.38867)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature);
export default __webpack_public_path__ + "static/media/feature.d802f47ac9a80df28c3765f36653e3ce.svg";
export { ForwardRef as ReactComponent };